import React, {Fragment} from "react";
import {ServiceTypeFilter} from "../../../../filters/ServiceType";
import {TransPorterFilter} from "../../../../filters/Transporter";
import {FacilityFilter} from "../../../../filters/Facility";
import {TruckFilter} from "../../../../filters/TruckType";
import {Button, DatePicker, Drawer, Form, Input, InputNumber, List, message, Popconfirm, Tooltip} from 'antd';
import {WasteStream} from "./WasteStreamForm";
import {ServiceGet, ServicePost, ServiceUpdate} from "../../../../models/service";
import {Config} from "../../../../controller/Global";
import {IndustryTypeFilter} from "../../../../filters/IndustryType";
import {JobDescription} from "../../../../filters/JobDescription";
import Divider from "antd/es/divider";
import TextArea from "antd/es/input/TextArea";

const moment = require('moment');
const FormItem = Form.Item;

const MANIFEST = Config.constant.service_type.manifest;
const BOL = Config.constant.service_type.bol;
const SERVICE = Config.constant.service_type.service;

class AddWorkOrderServiceForm extends React.Component {
  state = {
    data: [],
    visible: false,
    moderated: 0,
    service_date: moment().format('YYYY-MM-DD'),
    confirmLoading: false,
    service_type: MANIFEST
  };
  showDrawer = (service_type = MANIFEST) => {
    this.setState({visible: true, service_type: service_type});
  };
  onClose = () => {
    this.setState({visible: false, service_type: MANIFEST, confirmLoading: false, moderated: 0});
  };
  confirmDelete = (id) => {
    let data = [];
    this.state.data.forEach((item) => {
      if (item.id !== id) {
        data.push(item);
      }
    });
    this.setState({
      data: data,
    });
    this.props.onChange(data.map(item => item.id));
  };

  editService = (id) => {
    this.setState({ moderated: id });
    const form = this.props.form;
    ServiceGet(id)
      .then(response => {
        this.showDrawer(response.data.type);
        form.setFieldsValue({
          number_people: response.data.number_people,
          service_date: moment(response.data.service_date),
          job_description: response.data.job_description,
          shipping_info: response.data.shipping_info,
          special_info: response.data.special_info,
          discrepancy: response.data.discrepancy
        });
        this.service_type.handleChange({
          key: response.data.service_type.id,
          label: response.data.service_type.name
        });
        this.facility.handleChange({
          key: response.data.facility.id,
          label: response.data.facility.name
        });
        this.transporter.handleChange({
          key: response.data.transporter.id,
          label: response.data.transporter.name
        });
        this.truck_type.handleChange(response.data.truck_type.map(item => {
          return ({
            key: item.id,
            label: item.type_name
          })
        })[0]);
        response.data.type !== SERVICE && this.waste_stream_entity.handleChange(response.data.waste_stream, true)

      })
  };

  handleServiceForm = () => {
    const service_type = this.state.service_type;
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        this.setState({ confirmLoading: true });
        values['service_date'] = moment(values['service_date']).format('YYYY-MM-DD');
        values['type'] = service_type;
        values['truck_type'] = [values['truck_type']];
        ServicePost(values)
          .then(response => {
            this.setState({
              visible: false,
            });
            message.success('Service added successfully');
            form.resetFields();
            this.setState({ confirmLoading: false });
            this.fetchService(response.id);
          });
      }
    });
  };

  updateServiceForm = (id) => {
    const service_type = this.state.service_type
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        values['service_date'] = moment(values['service_date']).format('YYYY-MM-DD');
        if (!values['number_people'])
          values['number_people'] = null;
        values['type'] = service_type;
        values['truck_type'] = [values['truck_type']];
        ServiceUpdate(id, values)
          .then(response => {
            this.setState({
              visible: false,
            });
            message.success('Service updated successfully');
            form.resetFields();
            this.confirmDelete(response.id);
            this.fetchService(response.id);
          });
      }
    });
  }
  fetchService = (id) => {
    ServiceGet(id)
      .then(response => {
        const data = this.state.data;
        this.setState({
          data: [...data, response.data],
        });
        this.props.onChange(this.state.data.map(item => item.id));
      }
      )
  };

  handleChange = (value) => {
    const data = this.state.data;
    this.setState({
      data: [...data, value],
    });
    this.props.onChange([...data.map(item => item.id), value.id]);
  };

   handleDescriptionChange = (value) => {
    const form = this.props.form;
    form.setFieldsValue({
      job_description: value
    })
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)

  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const { fields, visible, data, moderated, service_date, confirmLoading, service_type } = this.state;
    const { getFieldDecorator } = this.props.form;
    const showAddBtn = this.state.data.length;
    return (
      <div className="row">
         {!showAddBtn && <React.Fragment>
            <div className="add-input-btn col-lg-5 col-12">
              <button onClick={() => this.showDrawer(MANIFEST)} type="button" className="btn add-field-btn">
                <i className="fa fa-plus" /> Create Manifest
              </button>
                <button onClick={() => this.showDrawer(BOL)} type="button" className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Create BOL
                </button>
              <button onClick={() => this.showDrawer(SERVICE)} type="button" className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Create Service
                </button>
            </div>
              <div className="add-input-btn col-lg-7 col-12 text-right">
              <button type="button" disabled className="btn add-field-btn">
                <i className="fa fa-plus" /> Sub Contractor
              </button>
                <button type="button" disabled className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Rental
                </button>
                <button type="button" disabled className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Materials
                </button>
                  <button type="button" disabled className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Equipment
                </button>
                <button type="button" disabled className="btn add-field-btn ">
                    <i className="fa fa-plus" /> Labor
                </button>
            </div>
          </React.Fragment> }
        <div className="col-12  padding-0">
          <List className="demo-loadmore-list" itemLayout="horizontal" dataSource={data} renderItem={item => (
            <List.Item actions={
              [<a onClick={() => this.editService(item.id)}>Edit</a>, <Popconfirm title="Are you sure delete this service?" onConfirm={() => this.confirmDelete(item.id)} okText="Yes" cancelText="No"><a>Delete</a></Popconfirm>]}>
              <List.Item.Meta
                description={
                  <div className="added-services">
                    <div className="row added-services-header">
                      <span>{item.type} Number</span>
                      <span>Service name</span>
                      <span>Service Date</span>
                      <span>Crew members</span>
                      <span>Transporter</span>
                      <span>Facility</span>
                      <span>Truck Type</span>
                    </div>
                    <div className="row">
                      <span>{item.manifest_number}</span>
                      <span>{item.service_type.name}</span>
                      <span>{item.service_date}</span>
                      <span>{item.number_people}</span>
                      <span>{item.transporter && item.transporter.name}</span>
                      <span>{item.facility.name}</span>
                      <span>{item.truck_type.map(item => `${item.type_name}, `)}</span>
                    </div>
                    <div className="row job-desc-view">
                      <div className="col-12">
                        <h4>Job Description <i className="fa fa-info-circle" /> :</h4>
                        <Tooltip placement="top" title={item.job_description}>
                          <p>{item.job_description ? item.job_description.substring(0, 100) : '-'}</p>
                        </Tooltip>
                      </div>
                    </div>
                    {item.type !== SERVICE &&
                      <Fragment>
                        <div className="row added-services-header multiple-desc">
                          <span className="quantity-serv">Code</span>
                          <span className="description-serv">Description</span>
                          <span className="quantity-serv">Quantity</span>
                          <span className="quantity-serv">Unit</span>
                          {/*<span className="quantity-serv">Price</span>*/}
                        </div>
                        {item.waste_stream.map((waste, index) => {
                          return <div key={index} className="row multiple-desc">
                            <span
                              className="quantity-serv ws-code">{waste.waste_stream ? waste.waste_stream.code : ''}</span>
                            <Tooltip placement="right" title={waste.waste_stream ? waste.waste_stream.description : ''}>
                              <span
                                className="description-serv info"> {waste.waste_stream ? waste.waste_stream.description : ''}</span>
                            </Tooltip>
                            <span className="quantity-serv">{waste.quantity}</span>
                            <span className="quantity-serv">{waste.waste_stream ? waste.waste_stream.unit : ''}</span>
                            {/*<span className="quantity-serv">{waste.price}</span>*/}
                          </div>
                        })}
                      </Fragment>
                    }
                  </div>} />
            </List.Item>
          )} />
        </div>
        {visible &&
        <Drawer title={(moderated ? "Update " : "Create ") + service_type} placement="right" onClose={this.onClose} visible={visible} className="floating-form service-drawer" destroyOnClose={true}>
          <Form>
            {service_type !== SERVICE &&
              <FormItem>
                {getFieldDecorator('waste_stream', {
                  rules: [{required: true, message: 'Please add waste stream(s)'}],
                })(<WasteStream service_type={service_type} onRef={ref => (this.waste_stream_entity = ref)} {...fields} type='workorder'/>)}
              </FormItem>
            }
            <div className="row">
              <div className="col-sm-4 col-12">
                <FormItem label="Service Type">
                  {getFieldDecorator('service_type', {
                    rules: [{required: true, message: 'Please select service type name'}],
                  })(<ServiceTypeFilter onRef={ref => (this.service_type = ref)} {...fields} />)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Service Date">
                  {getFieldDecorator('service_date', {
                    rules: [{required: true, message: 'Please choose service date'}],
                    // initialValue: moment(service_date, 'YYYY-MM-DD')
                  })(<DatePicker placeholder="Enter Service Date" className="drawer-datepicker w-100" {...fields} />)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Crew members">
                  {getFieldDecorator('number_people')(<InputNumber placeholder="Enter Numbers Of Crew members" min={1}/>)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Transporter">
                  {getFieldDecorator('transporter', {
                    rules: [{required: true, message: 'Please select Transporter'}],
                  })(<TransPorterFilter is_update={this.state.moderated} onRef={ref => (this.transporter = ref)} {...fields} />)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Facility">
                  {getFieldDecorator('facility', {
                    rules: [{required: true, message: 'Please select facility'}],
                  })(<FacilityFilter is_update={this.state.moderated} onRef={ref => (this.facility = ref)} {...fields} />)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Truck Type">
                  {getFieldDecorator('truck_type', {
                    rules: [{required: true, message: 'Please select truck type'}],
                  })(<TruckFilter onRef={ref => (this.truck_type = ref)} {...fields} single={true}/>)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Additional Description for Material Listed Above">
                  {getFieldDecorator('shipping_info', {
                  })(<Input  placeholder="Additional Description for Material Listed Above"/>)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Special Handling Instructions">
                  {getFieldDecorator('special_info', {
                  })(<Input  placeholder="Special Handling Instructions & additional info"/>)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <FormItem label="Discrepancy Indication Space">
                  {getFieldDecorator('discrepancy', {
                  })(<Input  placeholder="Discrepancy Indication Space"/>)}
                </FormItem>
              </div>
              <div className="col-sm-4 col-12">
                <div className="floating-label">
                  <FormItem label="Choose a template">
                    {getFieldDecorator('choose_description')(<JobDescription onChange={this.handleDescriptionChange} onRef={ref => (this.choose_description = ref)} {...fields} />)}
                  </FormItem>
                </div>
              </div>
              <div className="col-sm-1 col-12">
                <div className="floating-label job-divider">
                  <Divider>or</Divider>
                </div>
              </div>
              <div className="col-sm-7 col-12">
                <div className="floating-label">
                  <FormItem label="Enter Job Description">
                    {getFieldDecorator('job_description', {
                      rules: [{ required: true, message: 'Please enter job description' }],
                    })(<TextArea className="job-desc-field" autosize={true} placeholder="Enter Job Description" />)}
                  </FormItem>
                </div>
              </div>
            </div>
            <Button loading={confirmLoading} type="primary" htmlType="button" className="text-uppercase"
                    onClick={moderated ? () => this.updateServiceForm(moderated) : this.handleServiceForm}>{(moderated ? "Update " : "Create ") + service_type}</Button>
          </Form>
        </Drawer>
        }
      </div>
    );
  }
}

export const AddWorkOrderService = Form.create()(AddWorkOrderServiceForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/quotes/extra/AddWorkOrderServiceForm.jsx